import { Modal, ModalBody, ModalHeader } from "reactstrap";
import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AlertComponent from "../../_UI/Components/Alerts/AlertComponent";
import { commonsReducerActions } from "../../_services/store";
import { LoadingSpinnerButton, PathwayButton } from "../../_UI/Components/PathwayButtons";
import styled from "styled-components";
import { TwoButtonModalFooter } from "../../_UI/StyledComponents/PathwayModal";
import { sendFeedbackMessage } from "../services/store/commons.actions";

const SurveyModal = () => {
    const commons = useSelector((state) => state.commons);
    const dispatch = useDispatch();

    const [message, setMessage] = useState("");

    const submitCustomerMessage = useCallback(() => {
        if (message && message !== "") {
            dispatch(sendFeedbackMessage(message)).then(
                setTimeout(() => {
                    dispatch(commonsReducerActions.resetSurveyModal());
                }, 10000)
            );
            setMessage("");
        } else {
            dispatch(commonsReducerActions.setErrorMessageMissingInput());
        }
    }, [dispatch, message, setMessage]);

    const toggleModal = useCallback(() => {
        dispatch(commonsReducerActions.toggleSurveyModal());
        setMessage("");
    }, [dispatch]);

    return (
        <Modal className="modal-lg" isOpen={commons.displaySurveyModal}>
            <ModalHeader toggle={toggleModal}>Gib uns dein Feedback!</ModalHeader>
            <ModalBody>
                <AlertComponent errorMessages={commons.errorMessage} />

                <div className="input-group">
                    <textarea
                        name="textValue"
                        value={message}
                        rows="10"
                        placeholder="Feedback oder Problem melden..."
                        onChange={(e) => setMessage(e.target.value)}
                    />
                </div>
            </ModalBody>
            <SubmitFooter>
                <div />
                <LoadingSpinnerButton loading={!!commons.loading} onClick={submitCustomerMessage}>
                    Feedback senden
                </LoadingSpinnerButton>
                <PathwayButton color="secondary" onClick={toggleModal}>
                    Abbrechen
                </PathwayButton>
            </SubmitFooter>
        </Modal>
    );
};

export default SurveyModal;

const SubmitFooter = styled(TwoButtonModalFooter)`
    grid-template-columns: 0.6fr 0.3fr 0.2fr;
`;
